<template>
  <div class="packaging-management">
    <!-- 顶部信息和操作区 -->
    <div class="top-container">
      <!-- 左侧单号信息区 -->
      <div class="left-info">
        <div class="info-item">
          <label class="info-label">快递单号</label>
          <vxe-input class="info-input" placeholder="请输入快递单号"/>
        </div>
        <div class="info-item">
          <label class="info-label">商品编码</label>
          <vxe-input class="info-input" placeholder="请输入商品编码"/>
        </div>
        <div class="info-item">
          <label class="info-label">数量</label>
          <vxe-input class="info-input" value="1"/>
          <a-checkbox checked class="lock-checkbox">锁定</a-checkbox>
        </div>
        <div class="info-item">
          <label class="info-label">打包人</label>
          <vxe-input class="info-input" placeholder="请输入打包人"/>
          <a-checkbox class="lock-checkbox">锁定</a-checkbox>
          <a-checkbox class="scan-checkbox">扫描</a-checkbox>
        </div>
      </div>

      <!-- 中间订单信息区 -->
      <div class="middle-info">
        <div class="info-text">销售订单</div>
        <div class="info-text">快递单</div>
        <div class="info-text">序号</div>
        <div class="info-text">承运商</div>
        <div class="info-text">货主</div>
        <div class="info-text">包裹号</div>
        <div class="info-text">推荐包材</div>
        <div class="info-text">扫描包材</div>
        <div class="info-text">扫描条码</div>
        <div class="info-text">识别数量</div>
      </div>

      <!-- 右侧操作按钮区 -->
      <div class="right-actions">
        <a-button type="primary" class="action-btn">拆包</a-button>
        <a-button type="primary" class="action-btn">订单重新复核</a-button>
        <a-button type="primary" class="action-btn">包裹重新复核</a-button>
        <a-button type="primary" class="action-btn">补打快递</a-button>
        <a-button type="primary" class="action-btn">补打ASN码</a-button>
        <a-button type="primary" class="action-btn">订单重新复核</a-button>
      </div>
      <div class="right-actions">
        <a-checkbox class="packaging-scan" v-show="false"> </a-checkbox>
        <a-checkbox class="packaging-scan">开启录像 </a-checkbox>
        <a-checkbox class="packaging-scan">打印快递单 </a-checkbox>
        <a-checkbox class="packaging-scan">打印发货单 </a-checkbox>
        <a-checkbox class="packaging-scan">包材扫描  </a-checkbox>
        <a-checkbox class="packaging-scan">打印ASN码 </a-checkbox>
        <a-checkbox class="packaging-scan">快递打印校验</a-checkbox>
      </div>
    </div>

    <!-- 底部表格区域 -->
    <div class="table-container">
      <!-- 待扫描表格 -->
      <div class="left-table">
        <div class="table-header">待扫描</div>
        <a-table
          :columns="pendingColumns"
          :data-source="pendingData"
          bordered
          :pagination="false"
        >
          <template slot="emptyText">
            <div class="empty-table-placeholder"></div>
          </template>
        </a-table>
      </div>

      <!-- 切换按钮 -->
      <div class="switch-btn">
        <a-button shape="circle" size="small">
          <a-icon type="swap-right" />
        </a-button>
      </div>

      <!-- 已扫描标签页表格 -->
      <div class="right-table">
        <a-tabs defaultActiveKey="1">
          <a-tab-pane key="1" tab="已扫描"></a-tab-pane>
          <a-tab-pane key="2" tab="已扫描包材"></a-tab-pane>
          <a-tab-pane key="3" tab="已扫描SN"></a-tab-pane>
        </a-tabs>
        <a-table
          :columns="scannedColumns"
          :data-source="scannedData"
          bordered
          :pagination="false"
        >
          <template slot="emptyText">
            <div class="empty-table-placeholder"></div>
          </template>
        </a-table>
      </div>
    </div>

    <!-- 右侧统计数据 -->
    <div class="statistics-panel">
      <div class="stat-item">
        <div class="stat-label">未扫描数</div>
        <div class="stat-value blue">0</div>
      </div>
      <div class="stat-item">
        <div class="stat-label">已扫描数</div>
        <div class="stat-value green">0</div>
      </div>
      <div class="stat-item">
        <div class="stat-label">完成总单数</div>
        <div class="stat-value red">0</div>
      </div>
      <div class="stat-item">
        <div class="stat-label">完成总件数</div>
        <div class="stat-value black">0</div>
      </div>
      <div class="user-avatar">
        <a-avatar icon="user" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 待扫描表格列定义
      pendingColumns: [
        {
          title: '',
          dataIndex: 'check',
          width: 30,
          render: () => <a-checkbox />
        },
        {
          title: '条码',
          dataIndex: 'barcode',
          width: 100
        },
        {
          title: '码制',
          dataIndex: 'codeType',
          width: 80
        },
        {
          title: '商品条码',
          dataIndex: 'productBarcode',
          width: 120
        },
        {
          title: '商品',
          dataIndex: 'product',
          width: 150
        }
      ],
      // 待扫描表格数据
      pendingData: [
        { key: '1' },
        { key: '2' },
        { key: '3' },
        { key: '4' },
        { key: '5' }
      ],
      // 已扫描表格列定义
      scannedColumns: [
        {
          title: '',
          dataIndex: 'check',
          width: 30,
          render: () => <a-checkbox />
        },
        {
          title: '包裹号',
          dataIndex: 'packageNo',
          width: 100
        },
        {
          title: '包材编码',
          dataIndex: 'packagingCode',
          width: 100
        },
        {
          title: '包材名称/规格',
          dataIndex: 'packagingName',
          width: 150
        },
        {
          title: '已扫',
          dataIndex: 'scanned',
          width: 80
        }
      ],
      // 已扫描表格数据
      scannedData: [
        { key: '1' },
        { key: '2' },
        { key: '3' },
        { key: '4' },
        { key: '5' }
      ]
    };
  }
};
</script>

<style scoped>
.packaging-management {
  position: relative;
  padding: 16px;
  padding-right: 120px;
  background-color: #fff;
  min-height: 100vh;
}

/* 顶部信息区域样式 */
.top-container {
  display: flex;
  margin-bottom: 16px;
  gap: 24px;
}

.left-info {
  display: flex;
  flex-direction: column;
  gap: 60px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-label {
  width: 80px;
  text-align: right;
  font-size: 14px;
  color: #333;
}

.info-input {
  width: 200px;
}

.lock-checkbox {
  margin-left: 8px;
}

.scan-checkbox {
  margin-left: 8px;
}

.middle-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.info-text {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #666;
}

.right-actions {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.action-btn {
  width: 140px;
  height: 36px;
  font-size: 14px;
}

.packaging-scan {
  margin-top: 4px;
  padding: 6px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

/* 表格区域样式 */
.table-container {
  display: flex;
  gap: 12px;
}

.left-table, .right-table {
  flex: 1;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}

.table-header {
  padding: 8px 16px;
  border-bottom: 1px solid #e8e8e8;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.switch-btn {
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-table-placeholder {
  height: 200px;
  background-color: #fafafa;
}

/* 右侧统计面板样式 */
.statistics-panel {
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
  height: 100%;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  gap: 30px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
}

.blue {
  color: #1890ff;
}

.green {
  color: #52c41a;
}

.red {
  color: #f5222d;
}

.black {
  color: #000;
}

.user-avatar {
  margin-top: auto;
  margin-bottom: 20px;
}
</style>
